import { useState } from 'react';
import { Music } from 'lucide-react';

interface Props {
    img: string;
    /** Accessibility label, used only while the image loads successfully -
     *  never rendered as visible alt text, because a 404 (album with no
     *  cover art yet) otherwise shows the album title as a broken-image
     *  placeholder instead of the record icon. */
    title: string;
    /** Icon size for the record-disc fallback shown when the image fails. */
    iconSize?: number;
    className?: string;
}

// Cover-art <img> that swaps itself out for the record-disc icon fallback
// when the image fails to load - the same icon the parent renders when
// there's no art URL at all. Without this, a 404 renders the alt text
// (the album title) inside the browser's broken-image box.
export function AlbumArt({ img, title, iconSize = 28, className }: Props): React.JSX.Element {
    const [failed, setFailed] = useState(false);
    if (failed) {
        return <Music size={iconSize} strokeWidth={2.75} />;
    }
    return (
        <img
            className={className}
            src={img}
            alt={title}
            onError={() => setFailed(true)}
        />
    );
}
